// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import Cookies from 'js-cookie';
// ... existing imports ...

const TOKEN = 'token';
const AUTH_STATUS = 'authStatus'; // Add new constant for status

export type TokenType = {
  accessToken: string;
  refreshToken: string;
};

export const getToken = (): TokenType | undefined => {
  const token = Cookies.get(TOKEN);
  return token ? JSON.parse(token) : undefined;
};

export const getAuthStatus = (): 'signIn' | 'signOut' => {
  return (Cookies.get(AUTH_STATUS) as 'signIn' | 'signOut') || 'signOut';
};

export const removeToken = (): void => {
  Cookies.remove(TOKEN);
  Cookies.remove(AUTH_STATUS);
};

export const setToken = (value: TokenType): void => {
  Cookies.set(TOKEN, JSON.stringify(value), {
    secure: false,
    sameSite: 'strict',
  });
  Cookies.set(AUTH_STATUS, 'signIn', {
    secure: false,
    sameSite: 'strict',
  });
};
